import { datadogRum } from '@datadog/browser-rum';
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { checkAppVersion } from './checkVersion';
import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

datadogRum.init({
  applicationId: '11bb0963-be49-45fe-b293-e3b19a078894', // From DataDog
  clientToken: 'pub26722e63fd4bb2b371b239247c522b6f',      // From DataDog
  site: 'us5.datadoghq.com',
  service: 'production-frontend',
  env: 'production',
  version: '1.0.0', // Update this when you deploy new versions
  sessionSampleRate: 100, // Track 100% of sessions
  sessionReplaySampleRate: 20, // Record 20% of sessions
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input', // Masks sensitive data
});

datadogRum.startSessionReplayRecording();

checkAppVersion();


const stytch = new StytchB2BUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN, {
  cookieOptions: {
    domain: window.location.hostname,
    path: '/',
    availableToSubdomains: false,
  },
});

ReactDOM.render(
  <React.StrictMode>
     <StytchB2BProvider stytch={stytch}>
    <App /> 
    </StytchB2BProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
